<script setup lang="ts">
import { authApi } from '@libero/api-client/auth/api';
import AuthLayoutContent from '@libero/cityview/modules/app/views/layouts/AuthLayout/AuthLayoutContent.vue';
import Login from '@libero/cityview/modules/auth/views/forms/Login.vue';
import MicrosoftLogo from '@libero/theme/logos/microsoft.svg';
import Button from '@libero/ui-framework/Button/Button.vue';
import DividerText from '@libero/ui-framework/DividerText/DividerText.vue';
import Link from '@libero/ui-framework/Link/Link.vue';
import Typography from '@libero/ui-framework/Typography/Typography.vue';
import { useMutation } from '@tanstack/vue-query';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const { mutate: handleProviderLogin, isPending } = useMutation({
  mutationFn: authApi.providerLogin,
  onSuccess: (response) => {
    document.location.replace(response.url);
  },
});
</script>

<template>
  <AuthLayoutContent>
    <Button
      color="secondary"
      appearance="outline"
      size="lg"
      isFullWidth
      :isLoading="isPending"
      :onClick="handleProviderLogin"
    >
      <template #icon>
        <MicrosoftLogo />
      </template>

      <template #label>{{ t('auth.login-microsoft') }}</template>
    </Button>

    <DividerText class="auth-layout__divider-text">{{ t('auth.or-login-email') }}</DividerText>

    <Login />

    <Typography class="auth-layout__intro" tag="p" size="lg">
      {{ t('auth.no-account') }}

      <Link size="lg" :to="{ name: 'auth.register' }" :ariaLabel="t('auth.register')" isInline>
        {{ t('auth.click-to-register') }}
      </Link>

      <span>.</span>
    </Typography>
  </AuthLayoutContent>
</template>
